import { HttpParams } from '@angular/common/http'

export abstract class BaseWithId {
    // These values are initialised in the backend, we allow them to be undefined when we create them in the frontend.
    id?: number
    persistenceVersion?: number
}

export abstract class BaseList<T> {
    items: Array<T>

    protected constructor() {
        this.items = new Array<T>()
    }
}

export abstract class PaginatedList<T> extends BaseList<T> {
    pageIndex!: number
    pageSize!: number
    totalCount!: number
    totalPages!: number

    hasPreviousPage!: boolean
    hasNextPage!: boolean

    protected constructor() {
        super()
    }
}

export abstract class PaginatedSearchCriteria {
    page?: number
    pageSize?: number

    constructor(page?: number, pageSize?: number) {
        this.page = page
        this.pageSize = pageSize
    }

    httpParams(): HttpParams {
        let params = new HttpParams()

        if (this.page) {
            params = params.set('page', `${this.page}`)
        }
        if (this.pageSize) {
            params = params.set('pageSize', `${this.pageSize}`)
        }

        return params
    }
}
